import React from "react";

const SubmitBtn = () => {
  return (
    <button className="text-lg font-titleFont text-white bg-primeColor w-full lgl:w-auto py-2 px-20 rounded-md duration-500">
      Submit
    </button>
  );
};

export default SubmitBtn;
